export default __webpack_public_path__ + "static/media/DescribingPeople_07.3aad0953.png";